import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const merchantTransactionRangeApproval = {
  namespaced: true,

  state: () => ({
    allMerchantTransactionApprovalRanges: []
  }),

  getters: {
    _allMerchantTransactionApprovalRanges: state => state.allMerchantTransactionApprovalRanges
  },

  mutations: {
    ALL_MERCHANT_TRANSACTION_APPROVAL_RANGES (state, data) {
      state.allMerchantTransactionApprovalRanges = data
    }
  },

  actions: {
    CreateMerchantTransactionApprovalRange ({ rootState, dispatch }, { headers, data }) {
      /*
        {
          "merchantID": 0,
          "amountFrom": 0,
          "amountTo": 0,
          "createdByUserID": 0
        }
      */
      return new Promise((resolve, reject) => {
        api.post('/MerchantTransactionRangeApproval/CreateMerchantTransactiionApprovalrange', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    UpdateMerchantTransactiionApprovalRange ({ rootState, dispatch }, { headers, data }) {
      /*
        {
          "merchantTransactionRangeID": 0,
          "merchantID": 0,
          "amountFrom": 0,
          "amountTo": 0
        }
      */
      return new Promise((resolve, reject) => {
        rootState.loading = true
        api.post('/MerchantTransactionRangeApproval/UpdateMerchantTransactiionApprovalrange', data, { headers })
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            setTimeout(() => {
              rootState.loading = false
              resolve(response)
            }, 2000)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },

    GetAllMerchantTransactionApprovalRange ({ rootState, dispatch }, config) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get('/MerchantTransactionRangeApproval/GetAllMerchantTransactionApprovalRange', config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    },
    GetAllMerchantTransactionApprovalRangeByID ({ rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        // rootState.loading = true
        api.get(`/MerchantTransactionRangeApproval/GetAllMerchantTransactionApprovalRangeByID?MerhchantTransactionRangeID=${payload.merchantTransactionRangeID}`, payload.config)
          .then(response => {
            if (response.responseCode === '04') {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              return response.data
            }
          })
          .then(response => {
            // rootState.loading = false
            resolve(response)
          })
          .catch(error => {
            // rootState.loading = false
            if (error && error.response?.status === 401) {
              const headers = { Authorization: `${rootState.users.tokenType} ${rootState.users.apiRequestToken}` }
              store.dispatch('users/UnauthorizedUser', { headers })
            } else {
              rootState.loading = false
              reject(error)
            }
          })
      })
    }
  }
}

export default merchantTransactionRangeApproval
